import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, unref as _unref } from "vue"

const _hoisted_1 = { class: "max-w-screen-lg mx-auto my-6" }
const _hoisted_2 = { class: "flex flex-col w-full lg:items-start lg:justify-between lg:flex-row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-medium text-neutral-600" }, [
  /*#__PURE__*/_createTextVNode(" Please fill out all the required fields with the red asterisk ("),
  /*#__PURE__*/_createElementVNode("span", { class: "text-red-600" }, "*"),
  /*#__PURE__*/_createTextVNode(") ")
], -1)
const _hoisted_4 = { class: "mt-3 text-lg font-medium lg:pl-4 lg:mt-0 md:text-2xl text-neutral-600" }
const _hoisted_5 = { class: "block font-semibold md:inline-block text-neutral-900" }
const _hoisted_6 = {
  key: 0,
  class: "grid grid-cols-6 gap-6 mt-6"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-6 border-t border-gray-200" }, null, -1)
const _hoisted_8 = { class: "col-span-full" }
const _hoisted_9 = { class: "flex items-center col-span-6 space-x-3 justify end" }
const _hoisted_10 = { class: "flex items-center justify-end w-full space-x-3" }

import { ref, type PropType, computed, watch, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";

import { useVuelidate } from '@vuelidate/core'
import { required, requiredIf, minLength, helpers, integer, maxLength} from '@vuelidate/validators'

import pickBy from "lodash/pickBy";

import UserLayout from "@/layouts/UserLayout.vue";
import SectionTitle from "@/components/partials/SectionTitle.vue";
import MultiSelect from "@/components/inputs/MultiSelect.vue";
import PageLoader from "@/components/loaders/PageLoader.vue";
import ButtonComponent from "@/components/buttons/ButtonComponent.vue";
import ConfirmationModal from "@/components/modals/ConfirmationModal.vue";
import SuccessModal from "@/components/modals/SuccessModal.vue";
import ErrorModal from "@/components/modals/ErrorModal.vue";
import InterventionService from "@/classes/Interventions/InterventionService"
import ErrorValidation from "./Components/Classess/ErrorValidation";

import FormField from "@/views/interventions/Components/Input/FormField.vue"
import DownloadCourtHearing from "@/views/interventions/Components/Buttons/DownloadCourtHearing.vue";
import DownloadTelepsychiatry from "./Components/Buttons/DownloadTelepsychiatry.vue";

//Classes
import { errorResponse } from "@/helpers/errorMessage";
import { useNetworkStore } from "@/store/network";

//Interfaces
import { PatientInterface } from "@/interfaces/pages/InterventionForm/InterventionFormInterface";
import OnlineSynching from "@/classes/Synching/OnlineSynching";
import DownloadPsychologicalTesting from "./Components/Buttons/DownloadPsychologicalTesting.vue";

//Classes

export default /*#__PURE__*/_defineComponent({
  __name: 'EditPage',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const networkStore = useNetworkStore();


//Route params
const patientId = ref<number | null>(route?.params?.patient);
const caseId = ref<number | null>(route?.params?.case ?? null);
const interventionType = ref<number>(route?.params?.interventionType);
const intervention = ref<number>(route?.params?.intervention);

//Interface
const patient = ref<PatientInterface>({});

//Any
const formStructure = ref<any>('');
const item =ref<any>({});
const showError = ref(false);
const showErrorMessage = ref(null);

//Booleans
const showConfirmation = ref<boolean>(false);
const showSuccess = ref<boolean>(false);
const loading = ref<boolean>(false);
const processing = ref<boolean>(false);
const isCourtHearing = ref<boolean>(false);
const isTelepsychiatry = ref<boolean>(false);
const isPsychologicalTesting = ref<boolean>(false);

//Number
const selectedCase = ref<number|null>(route?.params?.case ?? null);
const isNetworkAvailable = computed<boolean>(():boolean => networkStore.isNetworkAvailable);
const onlineSync = new OnlineSynching();

const form = ref<any>({
	cases_id: selectedCase.value,
	interventionType: interventionType.value,
	params: [],
})

const errors =ref<any>({});

const init = ():void => {
	loading.value = true;
	InterventionService
		.edit(interventionType.value, intervention.value, patientId.value, isNetworkAvailable.value)
		.then(({data}) => {
			console.log(data.item.status);
			patient.value = data.patient
			formStructure.value = data.form 
			item.value = data.item;
			selectedCase.value = data.item.cases_id
			form.value.params = data.item.data 
			isCourtHearing.value = data.isCourtHearing 
            isTelepsychiatry.value = data.isTelepsychiatry
            isPsychologicalTesting.value = data.isPsychologicalTesting
		})
        .catch((e) => {
            if (e.response?.status == 404) {
                showError.value = true;
                showErrorMessage.value = 'Intervention does not exists!';
            }
        })
		.finally(() => {
			loading.value = false;
		});
}

const isRequired = (value:any, vm:any):boolean => {
	console.log(vm);
	return vm.is_required;
}

//Validations
const rules = computed(() => {

	const rules = {
		cases_id : {
			required: helpers.withMessage('Case id is required', requiredIf(caseId.value != null)),
		},
		params: {
			$each: helpers.forEach({
				value: { 
					requiredIfFuction: requiredIf(isRequired),
				},
			})
		}
	}; 

	return rules;
})
const vuelidate = useVuelidate(rules, form);

const validate = async ():void => {
    showError.value = false
    showErrorMessage.value = null;

	const result = vuelidate.value.$validate();

	processing.value = false;
	loading.value = true;
	showConfirmation.value = false;

	await result
		.then(async (res) => {

			if(res) {
				await save()
			} else {
                showError.value = true;
                showErrorMessage.value = 'Please fill up all required fields';
				errors.value = ErrorValidation.getErrors(vuelidate.value)
                errorResponse(errors.value);
			}
		}).catch((err) => {
			console.log(err);
            showError.value = true;
            showErrorMessage.value = 'There was an error on the system';
		})
		.finally(() => {
			loading.value = false;
		});
	}

const save = async (): void => {
	loading.value = true;
	showConfirmation.value = false;
	
	await InterventionService
		.update(
			item.value.id,
			patientId.value, 
			{
				cases_id: selectedCase.value,
				interventionType: interventionType.value,
				params: pickBy(form.value.params)
			},
			isNetworkAvailable.value
		)
		.then(() => {
			showSuccess.value = true;
		})
		.catch((error: object) => {
			errors.value = errorResponse(error.response?.data?.errors);
		})
		.finally(() => {
			loading.value = false;
		});
};

const redirectSuccess = (): void => {
	showSuccess.value = false;

	const route = caseId?.value ? `/patient/${patientId.value}/cases/${caseId.value}/interventions` : `/intervention/${patientId.value}/view`;

	router.replace(route);
};

watch(
	() => isNetworkAvailable.value,
	async (val) => {
        loading.value = false;
        await onlineSync.checkDrafts();
		init();
	}
);

onMounted(async () => {
    await onlineSync.checkDrafts();
	init()
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UserLayout, {
    hasBack: "",
    backLink: caseId.value ? `/patient/${patientId.value}/cases/${caseId.value}/interventions` : `/intervention/${patientId.value}/view`
  }, {
    lowerRight: _withCtx(() => [
      (isCourtHearing.value)
        ? (_openBlock(), _createBlock(DownloadCourtHearing, {
            key: 0,
            intervention: item.value.id
          }, null, 8, ["intervention"]))
        : _createCommentVNode("", true),
      (isTelepsychiatry.value)
        ? (_openBlock(), _createBlock(DownloadTelepsychiatry, {
            key: 1,
            intervention: item.value.id
          }, null, 8, ["intervention"]))
        : _createCommentVNode("", true),
      (isPsychologicalTesting.value)
        ? (_openBlock(), _createBlock(DownloadPsychologicalTesting, {
            key: 2,
            intervention: item.value.id
          }, null, 8, ["intervention"]))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(SectionTitle, {
            fontSmall: "",
            title: `${formStructure.value.label} Intervention`
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["title"]),
          _createElementVNode("p", _hoisted_4, [
            _createTextVNode("Patient's Name: "),
            _createElementVNode("span", _hoisted_5, _toDisplayString(patient.value?.name ?? ""), 1)
          ])
        ]),
        (!loading.value)
          ? (_openBlock(), _createElementBlock("form", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                (errors.value?.message)
                  ? (_openBlock(), _createElementBlock("p", {
                      key: 0,
                      class: _normalizeClass(["text-[10px] mt-1", errors.value?.message ? 'text-red-600' : 'text-gray-800']),
                      id: "email-error"
                    }, _toDisplayString(errors.value?.message), 3))
                  : _createCommentVNode("", true)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formStructure.value?.fields, (field, index) => {
                return (_openBlock(), _createBlock(FormField, {
                  key: index,
                  field: field,
                  form: form.value.params,
                  errors: errors.value,
                  patient: patient.value,
                  isEdit: true,
                  isDone: item.value.status === 'Done',
                  disabled: ""
                }, null, 8, ["field", "form", "errors", "patient", "isDone"]))
              }), 128)),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(ButtonComponent, {
                    btnWidth: "quinary",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (
								_unref(router).replace(
									caseId.value
										? `/patient/${patientId.value}/cases/${caseId.value}/interventions`
										: `/intervention/${patientId.value}/view`
								)
							))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Cancel")
                    ]),
                    _: 1
                  }),
                  _createVNode(ButtonComponent, {
                    btnWidth: "primary",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (showConfirmation.value = true))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Save Record")
                    ]),
                    _: 1
                  })
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(ConfirmationModal, {
        typeTwo: true,
        show: showConfirmation.value,
        onCancel: _cache[2] || (_cache[2] = ($event: any) => (showConfirmation.value = false)),
        onConfirm: _cache[3] || (_cache[3] = ($event: any) => (validate())),
        "cancel-text": "Cancel",
        "action-text": "Confirm",
        title: "Save Record",
        content: "Are you sure you wish to save this record?"
      }, null, 8, ["show"]),
      _createVNode(SuccessModal, {
        show: showSuccess.value,
        onConfirm: _cache[4] || (_cache[4] = ($event: any) => (redirectSuccess())),
        "action-text": "Close",
        title: "Success!",
        content: `${formStructure.value.label} Intervention has been Created`
      }, null, 8, ["show", "content"]),
      _createVNode(ErrorModal, {
        show: showError.value,
        content: showErrorMessage.value
      }, null, 8, ["show", "content"]),
      _createVNode(PageLoader, { show: loading.value }, null, 8, ["show"])
    ]),
    _: 1
  }, 8, ["backLink"]))
}
}

})